import React, { memo } from "react";

import { Text, HStack, Switch } from "@chakra-ui/react";
import colors from "app/colors";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import MakePrivateHelpButton from "modules/_shared/help-buttons/make-private-help-button";

interface IProps {
  draftId: string;
}

const ComposeMakePrivateToggle = ({ draftId }: IProps) => {
  const { draft, isDraftLoaded, toggleLocked } = useMessageThreadDraft({
    draftId,
  });

  if (!draft || !isDraftLoaded) return null;

  return (
    <HStack spacing={0}>
      <Switch size="sm" isChecked={draft?.isLocked} onChange={toggleLocked} />
      <Text fontSize="sm" color={colors.gray50} pl={2} m={0}>
        Make Private
      </Text>
      <MakePrivateHelpButton />
    </HStack>
  );
};

export default memo(ComposeMakePrivateToggle);
